var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 10C0 4.478 4.478 0 10 0s10 4.478 10 10-4.478 10-10 10S0 15.522 0 10Zm1.696 0A8.305 8.305 0 0 0 10 18.304 8.305 8.305 0 0 0 18.304 10 8.305 8.305 0 0 0 10 1.696 8.305 8.305 0 0 0 1.696 10ZM10 4.732c.937 0 1.821.322 2.491.909.696.609 1.08 1.428 1.078 2.305 0 1.29-.85 2.451-2.167 2.958a1.077 1.077 0 0 0-.69 1v.507a.18.18 0 0 1-.179.178H9.462a.18.18 0 0 1-.179-.178v-.48c0-.516.152-1.025.445-1.449.287-.415.69-.732 1.162-.913.762-.292 1.253-.928 1.253-1.623 0-.984-.962-1.785-2.143-1.785-1.18 0-2.143.801-2.143 1.785v.17a.18.18 0 0 1-.179.179H6.607a.18.18 0 0 1-.179-.179v-.17c0-.877.384-1.696 1.08-2.305A3.775 3.775 0 0 1 10 4.732Zm-.631 10.81a.893.893 0 1 1 1.262-1.263.893.893 0 0 1-1.262 1.263Z",
  clipRule: "evenodd"
})));
SvgQuestionCircle.displayName = "SvgQuestionCircle";
export { SvgQuestionCircle as ReactComponent };
export default SvgQuestionCircle;